<template>
  <div>
    <v-data-table
      v-if="!$store.state.grid && $vuetify.breakpoint.mdAndUp"
      :headers="headers"
      :loading="progress"
      :items="items"
      hide-default-footer
      :search="search"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      @click:row="onClickItem"
    >
      <template v-slot:top>
        <v-toolbar elevation="1" dark dense color="secondary darken-3" class="mb-1">
          <v-text-field
            v-model="search"
            clearable
            flat
            solo-inverted
            hide-details
            prepend-inner-icon="search"
            :label="$t('search')"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn icon @click="$store.state.grid = true">
            <v-icon>fa-table</v-icon>
          </v-btn>
        </v-toolbar>
      </template>
      <v-slide-y-transition class="py-0" group tag="tbody"></v-slide-y-transition>
      <template v-slot:item.openMarkers="{ item }">
        <slot v-bind:item="item" name="itemOpenMarkers"></slot>
      </template>
      <template v-slot:item.actions="{ item }">
        <slot v-bind:item="item" name="itemAction"></slot>
      </template>
      <template v-slot:no-data>
        <slot name="empty"></slot>
      </template>
      <template v-slot:footer>
        <div class="d-flex flex-wrap justify-end pa-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
          <span class="pt-2">{{$t('itemsPerPage')}}</span>
          <v-menu transition="scale-transition" origin="right top" offset-y>
            <template v-slot:activator="{ on }">
              <v-btn dark text color="primary" class="ml-2" v-on="on">
                {{ itemsPerPage }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(number, index) in [1,5,10,15,30, 50]"
                :key="index"
                @click="changeItemsPerPage(number)"
              >
                <v-list-item-title>{{ number }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
      <template v-slot:no-results>
        <v-icon color="secondary" class="mr-3" small>fa-search</v-icon>
        {{$t('noresults')}}
      </template>
    </v-data-table>

    <v-data-iterator
      v-if="!$vuetify.breakpoint.mdAndUp || $store.state.grid"
      :items="items"
      :search="search"
      hide-default-footer
      :items-per-page.sync="itemsPerPage"
      :loading="progress"
      :page="page"
      @page-count="pageCount = $event"
    >
      <template v-slot:header>
        <v-toolbar elevation="1" dark dense color="secondary darken-3" class="mb-1">
          <v-text-field
            v-model="search"
            clearable
            flat
            solo-inverted
            hide-details
            prepend-inner-icon="search"
            :label="$t('search')"
          ></v-text-field>
          <template v-if="$vuetify.breakpoint.mdAndUp">
            <v-spacer></v-spacer>
            <v-btn icon @click="$store.state.grid = false">
              <v-icon>fa-list</v-icon>
            </v-btn>
          </template>
        </v-toolbar>
      </template>
      <template v-slot:default="props">
        <v-row>
          <v-col v-for="(item,i) in props.items" :key="i" cols="12" sm="6" md="4" lg="3">
            <v-card elevation height="100%">
              <slot v-bind:item="item" name="cardContent"></slot>
            </v-card>
          </v-col>
        </v-row>
      </template>
      <template v-slot:loading>
        <v-container fill-height>
          <loading></loading>
        </v-container>
      </template>
      <template v-slot:no-data>
        <slot name="empty"></slot>
      </template>
      <template v-slot:no-results>
        <div class="d-flex justify-center pa-2">
          <v-icon color="secondary" class="mr-3" small>fa-search</v-icon>
          {{$t('noresults')}}
        </div>
      </template>
      <template v-slot:footer>
        <div class="d-flex flex-wrap justify-end pa-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
          <span class="pt-2">{{$t('itemsPerPage')}}</span>
          <v-menu transition="scale-transition" origin="right top" offset-y>
            <template v-slot:activator="{ on }">
              <v-btn dark text color="primary" class="ml-2" v-on="on">
                {{ itemsPerPage }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(number, index) in [1,5,10,15,30,50]"
                :key="index"
                @click="changeItemsPerPage(number)"
              >
                <v-list-item-title>{{ number }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
export default {
  props: {
    headers: Array,
    progress: Boolean,
    items: Array
    // search: String
  },
  data() {
    return {
      page: 1,
      search: "",
      itemsPerPage: 10,
      pageCount:0
    };
  },
  computed: {
    itemsPerPageRules() {
      let rules = [
        value => !!value || `${this.$t("itemsPerPage")} ${this.$t("required")}`,
        value => parseInt(value, 10) || "Must be a number",
        value => value < 30 || "Maximum reached"
      ];
      return rules;
    },
  },
  watch: {
    itemsPerPage(n, o) {
      this.$forceUpdate();
    },
    pageCount(n, o) {}
  },
  methods: {
    onClickItem(item) {
      this.$emit("clickItem", item);
    },
    changeItemsPerPage(numberInput) {
      if (
        numberInput !== parseInt(numberInput, 10) &&
        numberInput < 1 &&
        numberInput < 31
      )
        return;
      if (numberInput == parseInt(numberInput, 10)) {
        this.itemsPerPage = parseInt(numberInput, 10);
      }
      this.calculatePageCount();
      //  itemsPerPage = parseInt($event, 10)
    },
    changePageCount(pagecount) {
      if (pagecount !== parseInt(pagecount, 10)) return;
      this.pageCount = pagecount;
    },
    nextPage() {
      if (this.page + 1 <= this.pageCount) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
      this.calculatePageCount();
    },
    calculatePageCount() {
      this.pageCount = Math.ceil(this.items.length / this.itemsPerPage);
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Datatable.vue